import { useMultiLocationUtils } from '@frontend/payments-hooks';
import { PaymentConfigName, StripeConfigLocationType, usePaymentMethodConfig } from './use-payment-method-config';

interface UseWeaveAppStripeConfigOptions {
  paymentConfigName?: PaymentConfigName;
  locationId: string | undefined;
}

export const useWeaveAppStripeConfig = ({ paymentConfigName, locationId }: UseWeaveAppStripeConfigOptions) => {
  const { getLocationOpsType } = useMultiLocationUtils();
  const locationType =
    getLocationOpsType(locationId) !== 'REGULAR' ? StripeConfigLocationType.Dev : StripeConfigLocationType.Prod;
  const paymentMethodConfig = usePaymentMethodConfig({ paymentConfigName, locationType });

  return paymentMethodConfig;
};
